import type { TenderData } from "@/container/tender/types/tender-type";

// Utility function to map API tender to UI tender format
export function mapApiTenderToTenderData(apiTender: any): TenderData {
  const now = new Date();
  const endDate = new Date(apiTender.endDate);
  const startDate = new Date(apiTender.startDate);
  
  // Calculate time ago
  const timeDiff = now.getTime() - startDate.getTime();
  const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));
  const postedAgo = daysDiff === 0 ? 'Bu gün' : 
                   daysDiff === 1 ? '1 gün əvvəl' : 
                   daysDiff < 30 ? `${daysDiff} gün əvvəl` :
                   daysDiff < 365 ? `${Math.floor(daysDiff / 30)} ay əvvəl` :
                   `${Math.floor(daysDiff / 365)} il əvvəl`;

  // Format deadline
  const deadline = endDate.toLocaleDateString('az-AZ', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit'
  });

  // Status will be handled in component with translations

  // Get primary region (first one)
  const primaryRegion = apiTender.regions.length > 0 ? apiTender.regions[0].name : 'Bakı';

  return {
    id: apiTender.id,
    category: apiTender.category.name,
    companyName: 'Grand-Mart MMC', // Default company name since not in API
    companyLogo: '/GrandmartLogo.svg', // Default logo since not in API
    title: apiTender.title,
    description: apiTender.description,
    status: apiTender.status,
    version: apiTender.version,
    location: primaryRegion,
    postedAgo,
    deadline: `${deadline}-dək`,
    bids: `${apiTender.suggestionCount} təklif`,
    views: `${apiTender.viewCount} baxış`,
    slug: apiTender.slug,
    isVoted: apiTender.isVoted
  };
}